import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ParentMessagesSender {
  PARENT_URL = environment.PARENT_URL;

  private getTargetOrigin(): string {
    return environment.ENV === 'dev' ? '*' : this.PARENT_URL;
  }

  sendResize(height: number) {
    window.parent.postMessage({ heightChange: height }, this.getTargetOrigin());
  }

  getToken() {
    window.parent.postMessage({ getToken: true }, this.getTargetOrigin());
  }

  getUser() {
    window.parent.postMessage({ getUser: true }, this.getTargetOrigin());
  }

  displayLoader() {
    window.parent.postMessage({ showLoader: true }, this.getTargetOrigin());
  }

  hideLoader() {
    window.parent.postMessage({ hideLoader: true }, this.getTargetOrigin());
  }

  showGreyBackground() {
    window.parent.postMessage(
      { showGreyBackground: true },
      this.getTargetOrigin(),
    );
  }

  hideGreyBackground() {
    window.parent.postMessage(
      { hideGreyBackground: true },
      this.getTargetOrigin(),
    );
  }

  parentRedirect(url: string) {
    window.parent.postMessage({ redirect: url }, this.getTargetOrigin());
  }

  scrollTo(x: number, y: number) {
    window.parent.postMessage(
      { scrollTo: { x: x, y: y } },
      this.getTargetOrigin(),
    );
  }
}
